import * as types from './types';
import * as _ from 'lodash';

const INITIAL_STATE = {
  billingList: [],
  billingReportList: [],
  billingReportDetails: [],
  reportLoading: false,
  tableLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_BILLING_DETAILS_LIST:
      return { ...state, billingList: action.payload.data.Data };
    case types.GET_BILLING_REPORTS_LIST:
      return { ...state, billingReportList: action.payload.data.Data };
    case types.GET_BILLING_REPORTS_DETAILS:
      return { ...state, billingReportDetails: action.payload.data.Data };
    case types.BILLING_REPORT_LOAD:
      return { ...state, reportLoading: action.payload };
    case types.STUDENT_DATA_LOAD:
      return { ...state, tableLoading: action.payload };

    case types.CLEAR_DETAIL_REPORT:
      return { ...state, billingReportDetails: [] };
    case types.CLEAR_LIST_REPORT:
      return { ...state, billingReportList: [] };
    case types.BILLING_CHECKALL:
      let copiedData = state.billingList.slice();
      copiedData.forEach(x => {
        const foundRow = action.payload.currentRows.filter(row => {
          return row._original.Id === x.Id;
        });
        if (foundRow.length > 0) {
          x.Allowed = action.payload.checkAll;
        }
      });
      return { ...state, billingList: copiedData };
    case types.UPDATE_BILLING_DATA_CHECK:
      let newData = state.billingList.slice();
      let item = _.find(newData, { Id: action.payload.Id });
      if (!item) {
        return state;
      }
      item.Allowed = action.payload.Allowed ? 0 : 1;
      return {
        ...state,
        billingList: newData,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/billingaccount/state/reducer.js